<div class="platformsWrap">
    <div class="maxContainerWidth">
        <h2 class="text-gradient !mb-12">easy integration with all platforms </h2>
        <!-- <div class="imagesWrap hidden md:flex">
            <img src="assets/images/payment-gateway/IOS_logo.png" alt="">
            <img src="assets/images/payment-gateway/magento.png" alt="">
            <img src="assets/images/payment-gateway/woocommerce.png" alt="">
            <img src="assets/images/payment-gateway/easyintegration.png" alt="">
            <img src="assets/images/payment-gateway/android.png" alt="">
        </div> -->

        <div class="slideWrap">
            <ngx-slick-carousel class="carousel" 
                #slickModal="slick-carousel" 
                [config]="slideConfig" 
                >
                <div ngxSlickItem class=" flex" *ngFor="let d of data" >
                     <div class="slide flex justify-center"  >
                        <img src="assets/images/payment-gateway/{{d.name}}" alt="">
                     </div>
               </div>
               
    </ngx-slick-carousel>
        </div>
    </div>
</div>